import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';

type VerificationStrategy = 'sumsub' | 'idscan';

export const useVerificationStragety = (): VerificationStrategy => {
  const verifyDoc: boolean = useFeature(FeatureFlag.VerifyDoc);
  return verifyDoc ? 'sumsub' : 'idscan';
};
